import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../../redux/deviations/selectors';
const mapStateToProps = (state, { deviation  })=>({
        isOwner: getIsCurrentUserAuthorOf(state, deviation)
    });
export default connect(mapStateToProps);
